module.exports = __webpack_public_path__ + "static/media/450.7b4e82c8.webp";